import { createSlice } from '@reduxjs/toolkit';
import config, { getCurrentTheme } from './config';

export const themeSwitcherSlice = createSlice({
  name: 'themeSwitcher',
  initialState: {
    isActivated: false,
    changeThemes: getCurrentTheme(
      'changeThemes',
      config.changeThemes.defaultTheme || 'themedefault'
    ),
    topbarTheme: getCurrentTheme(
      'topbarTheme',
      config.topbarTheme.defaultTheme || 'themedefault'
    ),
    sidebarTheme: getCurrentTheme(
      'sidebarTheme',
      config.sidebarTheme.defaultTheme || 'themedefault'
    ),
    layoutTheme: getCurrentTheme(
      'layoutTheme',
      config.layoutTheme.defaultTheme || 'themedefault'
    ),
  },
  reducers: {
    switchActivation: (state) => {
      state.isActivated = !state.isActivated;
    },
    changeTheme: (state, action) => {
      const { attribute, themeName } = action.payload;
      const theme = getCurrentTheme(attribute, themeName);
      if (attribute === 'layoutTheme') {
        document.getElementsByClassName(
          'isomorphicContent'
        )[0].style.backgroundColor = theme.backgroundColor;
      }
      state[attribute] = theme;
    },
  },
});
export const { initializeState, changeTheme, switchActivation } =
  themeSwitcherSlice.actions;

export default themeSwitcherSlice.reducer;
